import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import StrataForm from './StrataForm'
import { FlexColumn } from '../styles/Containers'
import { FormTitle } from '../styles/Text'
import { InfoMessage, ProcessingMessage, SuccessMessage, WarningMessage } from '../common/UserMessage'
import pirTerminology from '../../util/pirTerminology'

function AutoStrata({ disabled = false }) {
  const { watch } = useFormContext()
  const strataState = watch('strataState')

  return (
    <FlexColumn>
      <FormTitle>{pirTerminology.getAssociationLabel('Information')}</FormTitle>
      <FlexColumn>
        {strataState === 'info' && (
          <InfoMessage>
            To determine if your request requires {pirTerminology.getAssociationLower()} authorization, please enter an address in the Property
            Information section above.
          </InfoMessage>
        )}
        {strataState === 'processing' && (
          <ProcessingMessage>Checking if {pirTerminology.getAssociationLower()} authorization is required for this property.</ProcessingMessage>
        )}
        {strataState === 'autoStrata' && (
          <SuccessMessage>{pirTerminology.getAssociationTitle()} authorization is required for this property.</SuccessMessage>
        )}
        {strataState === 'autoNoStrata' && (
          <SuccessMessage>{pirTerminology.getAssociationTitle()} authorization is not required for this property.</SuccessMessage>
        )}
        {strataState === 'error' && (
          <WarningMessage>
            An error occurred determining if {pirTerminology.getAssociationLower()} authorization is needed. Please continue with your request, and
            we’ll reach out if any further information is required.
          </WarningMessage>
        )}
      </FlexColumn>
      {strataState === 'autoStrata' && <StrataForm disabled={disabled} />}
    </FlexColumn>
  )
}

AutoStrata.propTypes = {
  disabled: PropTypes.bool
}

export default AutoStrata
